<template>
    <b-container fluid bg-dark style="padding: 0px;">

      <b-navbar type="dark" variant="secondary" sticky id="topbar" toggleable>

        <b-navbar-brand href="#" class="title">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="0 350 500 250" height="50"><defs><path d="M150 448.33L150 598.33L0 598.33L0 348.33L50 348.33L50 448.33L150 448.33ZM275 498.33L275 598.33L225 598.33L225 498.33L175 498.33L175 448.33L325 448.33L325 498.33L275 498.33ZM500 498.33L400 498.33L400 598.33L350 598.33L350 448.33L500 448.33L500 498.33ZM50 548.33L100 548.33L100 498.33L50 498.33L50 548.33Z" id="logo"></path></defs>
            <g><use xlink:href="#logo" class="logosvg"></use></g></svg>
        </b-navbar-brand>

        <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
        <b-collapse is-nav id="nav_dropdown_collapse">  
        
         <b-navbar-nav class="mx-auto">       
               <b-nav-form>
                  <v-select @input='addUserAsset()' style="fill: white;" v-model="searchAsset" id="coinInput" placeholder="Choose Coin" label="fullname" :options="assetsList"></v-select> 
              </b-nav-form> 
          </b-navbar-nav>  

          <!-- <b-navbar-nav>
            <b-nav-item 
            v-for='(item,index) in menuItems' :key='index'
            :to='item.link'>
            </b-nav-item>
          </b-navbar-nav> -->

          <b-navbar-nav class="ml-auto"> 

               <b-btn :hidden='status' class="my-2 my-0" @click="login" variant="outline-warning">Log In</b-btn>
               <b-btn :hidden='status' class="my-2 mx-2" variant="warning" @click="signUp">Sign Up</b-btn>
  
                  <b-nav-item-dropdown :hidden='!status' right>
                      <template slot="button-content">
                        <em v-if="status" >{{user.displayName || user.email}}</em>
                      </template>
                    <b-dropdown-item href="/">Profile</b-dropdown-item>
                    <b-dropdown-item @click="loadUserData" >Load</b-dropdown-item>
                    <b-dropdown-item @click="saveUserData" >Save</b-dropdown-item>
                    <b-dropdown-item @click='signOut' >Signout</b-dropdown-item>
                  
                  </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>  
      </b-navbar>
    <main>
      <b-container fluid>  
        <router-view></router-view>  
        <btr-signup v-if="signUpModal"
          v-bind:signUpModal="signUpModal"
          v-on:close="signUpModal=false">
        </btr-signup>
        <btr-login v-if="logInModal"
          v-bind:logInModal="logInModal"
          v-on:close="logInModal=false">
        </btr-login>
      <b-form-row>
        <b-col xs='12' sm='6' md='6' lg= '8' xl='9' class=""> 
          <b-form-row  class="">   
              <b-col v-if="settings.splashBox" lg="12" class="mt-2">
                  <btr-splash  
                  v-bind:user = 'user'
                  v-bind:content="settings.splashContent"
                  v-on:close-splash="openSplash($event)">
                  </btr-splash>
              </b-col>
              <btr-happy v-bind:wallet="walletList[0].address"></btr-happy>
                <btr-ticker
                  v-for="(asset, index) in userAssets" 
                  :key=index
                  v-on:close-ticker="removeUserAsset($event)"
                  v-bind:index=index
                  v-bind:asset="asset"
                  v-bind:baseCurr="baseCurr">
                </btr-ticker>
                
      <!-- debug box -->
                <!-- <b-col cols='12'>  
                  <b-card class="mt-2" style="
                    height:300px;
                    overflow:auto;
                    background-color:grey;
                    color:white;
                    scrollbar-base-color:gold;
                    font-family:sans-serif;
                    padding:10px;">
                    <b-btn @click="settings.debugBox = !settings.debugBox">Close Debug</b-btn>
                    <h3> User Info </h3>
                    <pre>{{user | pretty}} </pre>
                    <h3> User Settings </h3>
                    <pre>{{settings | pretty}} </pre>
                    <h3> PortFolio </h3>  
                    <pre>{{portfolio | pretty}} </pre>
                    <h3> User Assets </h3>
                    <pre>{{userAssets | pretty}} </pre>
                    <h3> Coin List </h3>
                    <pre>{{assetsList | pretty}} </pre>
                    <h3> Base</h3>
                    <pre>{{baseCurr | pretty}} </pre>
                  </b-card>
                </b-col> -->
      <!-- End debug Box -->
          </b-form-row> 
        </b-col> 
        
        <b-col xs='12' sm='6' md='6' lg= '4' xl='3' class="my-2">     
            <b-card no-body>
              <b-card-header>
                Portfolio
              </b-card-header>
              <b-card-body>
                <btr-donut 
                  title='donut'
                  v-on:updated="changeUpdateState($event)"
                  v-bind:update="update"
                  v-bind:portfolio="portfolio"
                  v-bind:labels="labels"
                  v-bind:baseCurr="baseCurr">
                </btr-donut>
                <br>
                <div v-for="(asset, index) in userAssets" :key=index>
                  <b-input-group
                      size="sm" 
                      class='mb-2'>
                      <!-- :append='asset.symbol'>  -->
                    
                    <b-input-group-prepend>
                      <b-btn readonly
                      :style="{'background-color': settings.colorlist[index]}"
                      style="border: none;">  
                      </b-btn> 
                      <b-btn class="portfolioAssetName">{{asset.name}}</b-btn>
                    </b-input-group-prepend>
                      <b-form-input class="portfolioAssetAmount" @input="updateChart()" v-model='asset.amount'></b-form-input>  
                    <b-input-group-append>
                      <b-input-group-text class="portfolioAssetSymbol">
                        {{asset.symbol}}
                      </b-input-group-text> 
                    </b-input-group-append>  
                  </b-input-group>   
                </div>       
              </b-card-body>

              <b-card-footer class="text-center">
                <h5> ${{(portfolioTotal()*baseCurr.data.price).toFixed(2)}} </h5>  
                <h6 slot="footer"> {{portfolioTotal().toFixed(6)}}<small>(BTC)</small></h6> 
              </b-card-footer>       
            
            </b-card>
          </b-col> 
      </b-form-row> 
    </b-container> 
  </main>  
  <footer >
     <b-nav class="footer" >
         <span class="footerbrand">
            &copy;  
            <svg @click="alertBox = !alertBox" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="0 350 500 250" height="25"><defs><path d="M150 448.33L150 598.33L0 598.33L0 348.33L50 348.33L50 448.33L150 448.33ZM275 498.33L275 598.33L225 598.33L225 498.33L175 498.33L175 448.33L325 448.33L325 498.33L275 498.33ZM500 498.33L400 498.33L400 598.33L350 598.33L350 448.33L500 448.33L500 498.33ZM50 548.33L100 548.33L100 498.33L50 498.33L50 548.33Z" id="footerlogo"></path></defs>
            <g><use xlink:href="#footerlogo"></use></g></svg>
        </span>
            <b-nav-item @click="openSplash({splashContent:'about', splashBox:'true'})">
              About Us
            </b-nav-item>   
            <b-nav-item @click="openSplash({splashContent:'privacy', splashBox:'true'})">
              Privacy
            </b-nav-item> 
            <b-nav-item @click="openSplash({splashContent:'disclaim', splashBox:'true'})">
              Disclaimer
            </b-nav-item> 
            <b-nav-item @click="openSplash({splashContent:'terms', splashBox:'true'})">
              Terms
            </b-nav-item> 
            <b-nav-item @click="openSplash({splashContent:'donate', splashBox:'true'})">
              Donate
            </b-nav-item> 
            <b-nav-item @click="openSplash({splashContent:'happyoffer', splashBox:'true'})">
              Grab Happiness
            </b-nav-item> 
            <!-- <b-nav-item :show="settings.admin" @click="openSplash({splashContent:'addcoin', splashBox:'true'})">
              Admin
            </b-nav-item>  -->

            <btr-social></btr-social>
           
            <b-nav-text id="footerUpdated" class="ml-auto mr-2 mt-1">
            Last Update: {{lastUpdated | date}}
            </b-nav-text>
      </b-nav>  
  </footer> 
  </b-container> 
</template>

<script>

import * as firebase from 'firebase'
import Icon from 'vue-awesome/components/Icon'
// import * as cryptoicons from './cryptocurrency-icons/dist/'
import { config } from './helpers/firebaseConfig'

export default {
  name: 'app',
  components: Icon,
  data () {
    return {
      update: false,
      lastUpdated: '',
      socket: [],
      searchAsset: null,
      status: false,
      portfolio: [],
      walletList: [ {
        name: '',
        address: '',
        type: ''
      }],
      baseCurr: {
        name: 'Bitcoin',
        symbol: 'BTC',
        exchange: 'Binance',
        data: {
          symbol: '',
          price: 1,
          percent: ''
        },
        amount: 0
      },
      user: {},
      settings: {
        lastupdated: '',
        debugBox: false,
        splashContent: 'first',
        splashBox: true,
        colorlist: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 159, 64, 0.2)',
          'rgba(0, 123, 0, 0.2)',
          'rgba(200, 123, 200, 0.2)',
          'rgba(0, 180, 180, 0.2)',
          'rgba(0, 74, 74, 0.2)',
          'rgba(220, 200, 74, 0.2)'
        ]
      },           // User Info
      assetsList: [],     // Coin List
      asset: {
        name: '',
        symbol: '',
        exchange: '',
        data: {
          percent: 0
        },
        amount: 0,
        percent: 0,
        base: false,
        resolveTo: ''
      },
      userAssets: [],
      labels: [],
      signUpModal: false,
      logInModal: false
    }
  },
  computed: {
    menuItems () {
      let menuItems = [
        {icon: 'face', title: 'Tour', link: '/signup'},
        {icon: 'lock_open', title: 'Sign up', link: '/signin'}
      ]
      if (this.userIsAuthenticated) {
        menuItems = [
        ]
      }
      return menuItems
    },
    userIsAuthenticated () {
      return this.user !== null
    }
  },
  methods: {
    changeUpdateState (state) {
      this.update = !state
    },
    openSplash (payload) {
      console.log('payload:', payload)
      this.settings.splashContent = payload.splashContent
      this.settings.splashBox = payload.splashBox
    },
    portfolioTotal: function () {
      let total = 0
      // console.log(this.activeUserAssets().length)
      if (this.userAssets.length > 0) {
        for (let i = 0; i < this.userAssets.length; i++) {
          if (this.userAssets[i].symbol === this.baseCurr.symbol) {
            this.userAssets[i].total = parseFloat(this.userAssets[i].amount)
          } else {
            this.userAssets[i].total = parseFloat(this.userAssets[i].data.price) * parseFloat(this.userAssets[i].amount)
          }
          total += this.userAssets[i].total
        }
      }
      return total
    },
    updateChart () {
      this.portfolio = this.userAssets.map(asset => {
        return asset.total
      })
      this.labels = this.userAssets.map(asset => {
        return asset.name
      })
      console.log('working out porfolio:', this.portfolio)
      this.update = true
    },
    signUp () {
      console.log('show signup modal')
      this.signUpModal = true
    },
    login () {
      console.log('show login modal')
      this.logInModal = true
    },
    signIn: function () {
      const provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().signInWithPopup(provider).then((result) => {
        this.user = result.user
        this.status = true
      }).catch(error => console.log(error))
    },
    signOut () {
      this.trashCollect()
      firebase.auth().signOut()
    },
    trashCollect () {
      console.log('collecting Trash')
      for (let i = 0; i < this.userAssets.length; i++) {
        this.removeUserAsset(i)
      }
    },
    addUserAsset () {
      let assetInfo = this.searchAsset
      console.log('search ass:', this.searchAsset)
      assetInfo.data = {}
      assetInfo.amount = 0
      assetInfo.state = true
      let d = new Date()
      assetInfo.added = d.toString()
      console.log('Adding asset:', assetInfo)
      this.userAssets.push(assetInfo)
      this.addWebSocket(this.userAssets.length - 1) // not pretty should probably do this a different way
      this.searchAsset = null
      this.updateChart()
    },
    removeUserAsset (index) {
      if (this.userAssets[index].base) {
        console.log('keeping base')
      } else {
        console.log('DeActivating asset:', this.userAssets[index].name, index)
        this.userAssets[index].web.close()
        this.userAssets.splice(index, 1)
      }
      this.updateChart()
    },
    saveUserPortfolio () { // save the user assets is good
      firebase.database()
        .ref('/user/' + this.user.uid + '/portfolio/')
        .set(this.userAssets)
        .then((data) => {
          console.log('Returned:', data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    saveUserSettings () {
      let d = new Date()
      this.settings.updated = d.toString()
      this.settings.email = this.user.email
      this.settings.displayName = this.user.displayName
      firebase.database()
        .ref('/user/' + this.user.uid + '/settings/')
        .set(this.settings)
        .then((data) => {
          console.log('Returned Settings:', data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    loadUserPortfolio () {
      firebase.database()
        .ref('/user/' + this.user.uid + '/portfolio/')
        .once('value')
        .then((data) => {
          if (data.val()) {
            console.log('Got User Data', data.val())
            this.trashCollect()  // clear out what ever is there
            this.userAssets = data.val() // push the loaded stuff to local user assets
            this.setupSockets() // set up new sockets
          } else {
            this.saveUserData() // or if there is no data save whatever is in the local state to the database
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    loadUserSettings () {
      firebase.database()
        .ref('/user/' + this.user.uid + '/settings/')
        .once('value')
        .then((data) => {
          if (data.val()) {
            console.log('Got User Settings', data.val())
            this.settings = data.val() // push the loaded stuff to local user assets
          } else {
            this.saveUserSettings() // or if there is no data save whatever is in the local state to the database
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    loadUserData () {
      this.loadUserSettings()
      this.getWalletList()
      this.loadUserPortfolio()
    },
    saveUserData () {
      this.saveUserSettings()
      this.saveUserPortfolio()
    },
    loadDefaultData () {
      this.userAssets = [
        {
          name: 'Bitcoin',
          symbol: 'BTC',
          exchange: 'Binance',
          data: {
            price: 0,
            percent: 0
          },
          amount: 0,
          base: true,
          resolveTo: 'USDT',
          link: ''
        }
      ]
      console.log('Loaded Default Data:')
      this.setupSockets()
    },
    getWalletList () { // this is good and clean
      console.log('Getting Wallet List')
      firebase.database().ref('/user/' + this.user.uid + '/wallets')
      .once('value')
      .then((data) => {
        console.log('back from the Database', data.val)
        // this.assetsList = data.val()
        const obj = data.val()
        const wallets = []
        for (let key in obj) {
          wallets.push({
            id: key,
            name: obj[key].name,
            address: obj[key].address,
            type: obj[key].type
          })
        }
        this.walletList = wallets
      })
      .catch((error) => {
        console.log(error)
      })
    },
    getAssetsList () { // this is good and clean
      console.log('Getting Assets List')
      firebase.database().ref('assets')
      .once('value')
      .then((data) => {
        console.log('back from the Database', data.val)
        // this.assetsList = data.val()
        const obj = data.val()
        const assets = []
        for (let key in obj) {
          assets.push({
            id: key,
            fullname: obj[key].name + ' (' + obj[key].symbol + ')',
            name: obj[key].name,
            symbol: obj[key].symbol,
            exchange: obj[key].exchange,
            resolveTo: obj[key].resolveTo,
            link: obj[key].link,
            note: obj[key].note,
            added: obj[key].added
          })
        }
        this.assetsList = assets
      })
      .catch((error) => {
        console.log(error)
      })
    },
    setupSockets () {
      console.log('Setup the sockets:')
      for (let i = 0; i < this.userAssets.length; i++) {
        this.addWebSocket(i)
        // this.userAssets.total = parseFloat(this.userAssets[i].data.price) * parseFloat(this.userAssets[i].amount)
        // this.total += this.userAssets.total
      }
    },
    addWebSocket (index) {
      let quote = ''
      if (this.userAssets[index].symbol === this.baseCurr.symbol) {
        quote = this.userAssets[index].resolveTo
      } else {
        quote = this.baseCurr.symbol
      }
      let url = 'wss://stream.binance.com:9443/ws/' + this.userAssets[index].symbol.toLowerCase() + quote.toLowerCase() + '@ticker'
      console.log('websocket URL:', url)
      this.userAssets[index].web = new WebSocket(url)
      // this funky syntax below is to ensure you pass "this" into the websocket callback?
      this.userAssets[index].web.onopen = (event) => {
        console.log('Open this socket:', event)
      }
      this.userAssets[index].web.onclose = (event) => {
        console.log('closed socket:', event)
      }
      this.userAssets[index].web.onmessage = (event) => {
        // console.log('Tick:', index, event.data)
        let tick = JSON.parse(event.data)
        let d = new Date()
        this.userAssets[index].data =
        {
          price: parseFloat(tick.b),
          percent: parseFloat(tick.P),
          open: parseFloat(tick.o),
          close: parseFloat(tick.c),
          high: parseFloat(tick.h),
          low: parseFloat(tick.l),
          updated: d.toString()
        }
        this.lastUpdated = d
        if (this.userAssets[index].symbol === this.baseCurr.symbol) {
          this.baseCurr.data = this.userAssets[index].data
        }
        // console.log('got ticker:', index, this.userAssets[index].data)
        // document.title = this.tickerData.b + '|' + this.symbolFocus.pair
      }
    }
  },
  // //////////////////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////////
  mounted () {
    this.getAssetsList()
    setTimeout(this.updateChart, 1000)
    setInterval(this.updateChart, 60000)
    // this.setupSockets()
    // this.getBase(this.baseCurr.symbol, 'USDT') // hardwiring USDT is not nice... SORT
  },
  beforeCreate: function () {
    firebase.initializeApp(config)
    firebase.auth().onAuthStateChanged((response) => {
      if (response) {
        this.user = response
          // LOAD EXISING ACCOUNTS HERE
        this.status = true
        console.log('Got a User')
        console.log('Userdata', this.user)
        // load user info !!!!!!!!!!!!!!!!!!!!!!
        this.loadUserPortfolio()
        this.getWalletList()
        this.loadUserSettings()
      } else {
        console.log('No User')
        this.user = null
        this.status = false
        this.loadDefaultData()
      }
    })
  }
}
</script>


<style scoped>


#app {
  font-family: 'Lato', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: rgb(73, 73, 73);
  margin-top: 10vh;
}

b-containter fluid{
  margin-right: 0;
  margin-left: 0;
}

main {
  min-height: calc(100vh - 120px);
  background-color: rgba(73, 73, 73, 0.5);
}
#topbar {
  height: 70px;
  border-bottom: rgba(255, 192, 7, 1) solid 1px;
}
nav.navbar.navbar-light {
  background-color: rgba(255, 192, 7, 1);
  color: white;
}
a.dropdown-item:hover {
  color: rgba(255, 192, 7, 1);
}  
a.dropdown-item:focus {
  border: none;
  color: rgba(255, 192, 7, 1);
  outline: none;
}
#coinInput{
  font-family: 'Lato';
  min-width: 25vw;
  width: 100%;
  border: 1px solid rgba(255, 192, 7, 1);
  border-radius: 5px;
  background-color: white;
}
.dropdown-menu{
  font-family: 'Lato';
  position: absolute;
}
#logo {
  fill:rgba(255, 192, 7, 1);
}
#logo:hover {
  fill:rgba(255, 0, 7, 0.5);
}
#commentsButton {
  color: rgba(255, 192, 7, 1);
  background-color:rgba(108, 117, 125, 1);
}
.footer {
  font-family: 'Lato';
  border-top: rgba(108, 117, 125,1) solid 1px;
  background-color:rgba(255, 192, 7, 1);
  height: 50px;
}
a.nav-link {
  padding-top: 12px;
  color:grey;
}
.socialicon {
  margin: 10px;
  color: grey;
}
#footerlogo {
  fill:rgba(108, 117, 125,1);
}
#footerlogo:hover {
  fill:rgba(255, 0, 7, 0.5);
}
#footerUpdated {
  font-size: 0.7rem;
  color: grey;
}
.footerbrand {
  font-family: 'Gruppo', cursive;
  padding:10px;
  font-size: 1.0em;
  color: white;
}
.card{
  font-family: 'Lato';
  border: rgba(255, 192, 7, 1);
  word-wrap: none;
}
.card-header{
  background-color:rgba(255, 192, 7, 1);
  font-family: 'Lato';
  color: white;
  padding: 7px;
  height: 35px;
} 
.card-footer{
  border: 1px solid white;
  background: grey;
  color: white;
}  
.close{
  color: grey;
  background: none;
  font-size: 2rem;
  border: none;
  text-shadow: none;
  opacity: 1;
}
.portfolioAssetName{
  width: 9rem;
  text-align: center;
  font-family: Lato;
  font-size: 80% !important;
  word-break: break-word;
  padding-right: 7px;
}  
.portfolioAssetAmount{
  min-width: 5rem;
  text-align: right;
  font-family: Lato;
  font-size: 80% !important;
  word-break: break-word;
  padding-right: 7px;
}  
.portfolioAssetSymbol{
  width: 4rem;
  /* padding-left: 3px;
  padding-right: 5px; */
  text-align: left;
  font-family: Lato !important;;
  font-size: 80% !important;
}  
@media (min-width: 800) {
  body {
    background-color: purple;
  }
}

</style>


// WEBPACK FOOTER //
// src/App.vue